import { Component, OnInit } from '@angular/core';
import { CommonService } from 'app/services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ftp-files',
  templateUrl: './ftp-files.component.html',
  styleUrls: ['./ftp-files.component.scss']
})
export class FtpFilesComponent implements OnInit {

  displayedColumns: string[] = ['company', 'zips', 'total_files', 'success', 'failed', 'remaining', 'status'];
  dataSource;
  id: any;
  searchValue = '';
  length: any;
  pageSize: any;
  index: any;
  currentUser = {};
  params: { page: number; limit?: number, searchKey?: any };

  constructor(
    private commonService: CommonService,
    public router: Router, public dialog: MatDialog) {
  }

  ngOnInit() {
    this.params = { limit: 15, page: 1 };
    this.getList();
  }

  applyFilter(value) {
    this.params['searchKey'] = value;
    this.params.page = 1;
    this.getList();
  }

  pageEvent(event) {
    this.params.limit = event.pageSize;
    this.params.page = event.pageIndex + 1;
    this.getList();
  }

  getList() {
    this.commonService.getFTPfiles(this.params).subscribe(res => {
      if (res.status == 1) {
        this.dataSource = new MatTableDataSource(res.data.data);
        this.length = res.data.total;
        this.pageSize = res.data.per_page;
        this.index = res.data.current_page;
      }
    })
  }
  
  navigate(element, blank) {
    this.router.navigate([]).then(result => { window.open("#/company_details/" + element.company_id+"/bulkStatus", '_blank'); });
  }

  getReaminingRecords(element, type='record') {

    let total = element.total_files;
    let success = (element.success_files >0)?element.success_files:0;
    let failed = (element.failed_files >0)?element.failed_files:0;
    let remain = total - (success + failed);
    
    if (type == 'record') {
      return remain;
    } else {
      if (remain == total) {
        return 'Open';
      } 
      else if (remain <= 10) {
        return 'Completed';
      }
      else if(remain < total || remain > total) {
        return 'In-progress';
      }
    }
  }

}
